/* VISTA — motion-core.js · pure, testable motion logic (UMD).
   Browser: exposes window.VISTAMotion. Node: module.exports (tests). */
(function (root, factory) {
  var api = factory();
  root.VISTA = root.VISTA || {};
  root.VISTAMotion = api;
  if (typeof module !== 'undefined' && module.exports) { module.exports = api; }
})(typeof self !== 'undefined' ? self : this, function () {
  function motionOn(attr) { return attr === 'on'; }

  function linkShouldTransition(a) {
    a = a || {};
    if (!a.href) return false;
    if (a.href.charAt(0) === '#') return false;
    if (a.href.indexOf('javascript:') === 0) return false;
    if (a.sameOrigin === false) return false;
    if (a.target === '_blank') return false;
    if (a.download) return false;
    if (a.noFlash) return false;
    if (a.cartOpen) return false;
    if (a.button && a.button !== 0) return false;
    if (a.metaKey || a.ctrlKey || a.shiftKey) return false;
    return true;
  }

  function transitionKind(a) {
    a = a || {};
    if (!linkShouldTransition(a)) return 'none';   // mesmas exclusões (#, externo, _blank, download, cart, modificadores)
    if (a.inHeader) return 'curtain';              // navbar é a cortina (precedência)
    return 'page';                                 // todo o resto que muda de URL: zoom direcional
  }

  var REVEAL_TYPES = { up: 1, fade: 1, mask: 1, line: 1 };
  function revealVariant(raw) {
    if (!raw) return { type: 'up', index: 0 };
    var parts = String(raw).split(':');
    var type = REVEAL_TYPES[parts[0]] ? parts[0] : 'up';
    var index = parseInt(parts[1], 10);
    if (isNaN(index) || index < 0) index = 0;
    return { type: type, index: index };
  }

  return { motionOn: motionOn, linkShouldTransition: linkShouldTransition, transitionKind: transitionKind, revealVariant: revealVariant };
});
